module.exports = __webpack_public_path__ + "img/nyu_cusp_logo.f7eafb4c.png";